import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Building2, Users, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './About.css';

export function About() {
    const { language } = useLanguage();
    const isRtl = language === 'ar';
    const L = (ar, en) => isRtl ? ar : en;

    return (
        <main className="sym-about-page" dir={isRtl ? 'rtl' : 'ltr'}>
            <section className="sym-hero-dark">
                <div className="lux-container">
                    <nav className="lux-bread-nav">
                        <Link to="/" className="lux-home-link">{L('الرئيسية', 'Home')}</Link>
                        <ChevronRight size={14} color="#fff" style={{opacity: 0.5}} className={isRtl ? 'rev-icon' : ''} />
                        <span className="lux-current">{L('من نحن', 'About Us')}</span>
                    </nav>
                    <h1 className="sym-main-title-light">{L('قصة أيونك للهندسة', 'The Story of Ayonk Engineering')}</h1>
                    <div className="sym-dash-gold"></div>
                    <p className="sym-main-sub-light">
                        {L('منذ 2019، نجمع بين الدقة الهندسية والفخامة المعمارية لنبني مستقبلاً يليق بعملائنا وتطلعاتهم.', 
                        'Since 2019, we combine engineering precision and architectural luxury to build a future that suits our clients.')}
                    </p>
                </div>
            </section>

            <section className="sym-stats">
                <div className="lux-container">
                    <div className="sym-stats-grid">
                        <div className="sym-stat-card">
                            <div className="sym-icon"><Building2 size={32} color="#d4af37" /></div>
                            <span className="sym-num">+100</span>
                            <span className="sym-lab">{L('مشروع منفذ', 'Completed Projects')}</span>
                        </div>
                        <div className="sym-stat-card">
                            <div className="sym-icon"><Users size={32} color="#d4af37" /></div>
                            <span className="sym-num">2019</span>
                            <span className="sym-lab">{L('سنة الانطلاق', 'Established Year')}</span>
                        </div>
                        <div className="sym-stat-card">
                            <div className="sym-icon"><MapPin size={32} color="#d4af37" /></div>
                            <span className="sym-num">2</span>
                            <span className="sym-lab">{L('فروع عاملة', 'Active Branches')}</span>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sym-branches">
                <div className="lux-container">
                    <h2 className="sym-sec-title">{L('توسعنا الجغرافي', 'Our Footprint')}</h2>
                    <div className="sym-branches-grid">
                        <div className="sym-branch-card">
                            <span className="sym-year">2019</span>
                            <h3>{L('فرع الإسماعيلية', 'Ismailia Branch')}</h3>
                            <p>{L('المقر الرئيسي ومركز العمليات الهندسية والتصميم المعماري الحديث.', 'The main headquarters and the hub for engineering operations.')}</p>
                            <div className="sym-location-tag" style={{display:'flex', gap:'8px', marginTop:'20px', color:'#d4af37'}}>
                                <MapPin size={18} /> <span>{L('الإسماعيلية، حي ثالث', 'Ismailia')}</span>
                            </div>
                        </div>
                        <div className="sym-branch-card">
                            <span className="sym-year">2023</span>
                            <h3>{L('فرع سيناء', 'Sinai Branch')}</h3>
                            <p>{L('مركز بئر العبد، انطلاقة جديدة لخدمة مشاريع التنمية والبناء.', 'Bir al-Abd center, a new launch to serve development.')}</p>
                            <div className="sym-location-tag" style={{display:'flex', gap:'8px', marginTop:'20px', color:'#d4af37'}}>
                                <MapPin size={18} /> <span>{L('بئر العبد، سيناء', 'Bir al-Abd')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sym-team">
                <div className="lux-container">
                    <h2 className="sym-sec-title">{L('فريق الإدارة', 'Leadership Team')}</h2>
                    <div className="sym-team-flex">
                        <div className="sym-member-card">
                            <div className="sym-member-initial">K</div>
                            <h4>{L('كريم منصور', 'Kareem Mansour')}</h4>
                            <span className="sym-member-role">{L('المدير التنفيذي', 'CEO')}</span>
                        </div>
                        <div className="sym-member-card">
                            <div className="sym-member-initial">K</div>
                            <h4>{L('خالد محفوظ', 'Khaled Mahfouz')}</h4>
                            <span className="sym-member-role">{L('مدير المشاريع', 'Project Manager')}</span>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
